// Plays the hero film only while on screen and only when the visitor allows motion.
class QoHeroVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    // The poster paints first; otherwise the film covers it and becomes a slow LCP.
    const poster = this.querySelector('.qo-hero__poster');
    this.posterReady = poster ? poster.decode().catch(() => {}) : Promise.resolve();
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.sync = this.sync.bind(this);
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.sync();
    });
    this.observer.observe(this);
    this.motion.addEventListener('change', this.sync);
    this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.motion?.removeEventListener('change', this.sync);
  }

  // Data saver or 2G/3G keeps the poster only: the film would stall and cost the visitor data.
  get slowNetwork() {
    const connection = navigator.connection;
    return Boolean(connection && (connection.saveData || /(^|-)2g|3g/.test(connection.effectiveType)));
  }

  sync() {
    if (this.visible && !this.motion.matches && !this.slowNetwork) {
      this.posterReady.then(() => {
        if (this.visible) this.video.play().catch(() => {});
      });
    } else {
      this.video.pause();
    }
  }
}

if (!customElements.get('qo-hero-video')) customElements.define('qo-hero-video', QoHeroVideo);
